<template>
  <section>
    <div class="input-group input-group-sm">
      <div class="input-group-prepend input-group-sm">
        <b-form-select size="sm" class="form-control"
                       v-model="rangeFilterData['fromSign'][data.column]"
                       v-on:change="changeSing(rangeFilterData['fromSign'][data.column], rangeFilterData['fromVal'][data.column], rangeFilterData)"
                       :options="options"
        >
        </b-form-select>
      </div>
      <b-form-input size="sm" class="form-control"
                    v-model="rangeFilterData['fromVal'][data.column]"
                    type="number"
                    v-on:change="changeRangeVal(rangeFilterData['fromSign'][data.column], rangeFilterData['fromVal'][data.column], rangeFilterData, filterReset)"
                    placeholder="с"
      ></b-form-input>
    </div>
    <div class="input-group input-group-sm">
      <div class="input-group-prepend input-group-sm">
        <b-form-select size="sm" class="form-control"
                       v-model="rangeFilterData['toSign'][data.column]"
                       v-on:change="changeSing(rangeFilterData['toSign'][data.column], rangeFilterData['toVal'][data.column], rangeFilterData)"
                       :options="options">
        </b-form-select>
      </div>
      <b-form-input size="sm" class="form-control"
                    v-model="rangeFilterData['toVal'][data.column]"
                    type="number"
                    v-on:change="changeRangeVal(rangeFilterData['toSign'][data.column], rangeFilterData['toVal'][data.column], rangeFilterData, filterReset)"
                    placeholder="по"></b-form-input>
    </div>
  </section>
</template>

<script>

export default {
  name: "RangeFilter",
  props: {
    data: Object,
    changeSing: Function,
    changeRangeVal: Function,
  },
  data() {
    return {
      rangeFilterData: {
        'fromSign': {},
        'fromVal': {},
        'toSign': {},
        'toVal': {},
      },
      options: [
        {value: '=', text: '='},
        {value: '>', text: '>'},
        {value: '<', text: '<'}
      ],
    }
  },
  methods: {
    filterReset: function () {
      this.rangeFilterData = {
        'fromSign': {},
        'fromVal': {},
        'toSign': {},
        'toVal': {},
      }

      return {
        'fromSign': {},
        'fromVal': {},
        'toSign': {},
        'toVal': {},
      }
    }
  },
  computed: {
  },
}
</script>

<style scoped>

</style>